import moment from "moment";
import { ValueOrDots } from "../../../components/exportWord/partials";
import { useEffect, useState } from "react";
import { searchApprovalConfig } from "../../../category/services/approvalConfigServices";
import { RESPONSE_STATUS_CODE } from "../../../constants/moduleConsts";
import 'moment/locale/vi';

moment.locale('vi');

const TemplateDeXuatLamThemGio = (props: any) => {
  const { data } = props;

  const [configDuyet, setConfigDuyet] = useState<any>([])

  const giamDoc = configDuyet.find((config: any) => config.code === "HRM.APPROVAL.DIRECTOR");
  const toChucHanhChinh = configDuyet.find((config: any) => config.code === "HRM.APPROVAL.TCHC");

  useEffect(() => {
    getConfigDuyet();
  }, [])

  const getConfigDuyet = async () => {
    try {
      const { data } = await searchApprovalConfig({
        pageIndex: 1,
        pageSize: 9999
      });
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        const configDuyet = data.data.content.find((config: any) => config.letterType.code === "DKLT");
        configDuyet && setConfigDuyet(configDuyet?.approvingInfo);
      }
    } catch (err) {
      console.error("ERROR", err);
    }

  }

  return (
    <div className="word spaces px-70 colors-word">
      <div className="spaces text-center flex flex-between">
        <div>
          <p className="fw-600">
            <span className="spaces text-uppercase ml-5">
              <ValueOrDots className="" value={data?.dataDangKy?.donViCongTac?.name || ""} size={70} />
            </span>
          </p>
          <p className="fw-600">
            <span className="spaces text-uppercase ml-5">
              Phòng hành chính quản trị
            </span>
          </p>
        </div>
        <div className="fw-600">
          <p>CỘNG HOÀ XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
          <p>
            <span className="header-underline">Độc lập - Tự do - Hạnh phúc</span>
          </p>
        </div>
      </div>
      <div className="text-center spaces mt-20">
        <p className="text-uppercase fw-600 fs-lg">Đề xuất thêm giờ</p>
      </div>
      <div className="flex spaces ml-260 mt-10">
        <span className="fw-600 spaces mt-3 mr-5 title-kinh-gui">Kính gửi: </span>
        <div>
          <p>
            <ValueOrDots value={giamDoc ? `${giamDoc?.name} ${data?.dataDangKy?.donViCongTac?.name || ""}`  : ""} size={30} />
          </p>
          <p>
           <ValueOrDots value={toChucHanhChinh ? `Trưởng phòng ${toChucHanhChinh?.name}` :  ""} size={30} />
          </p>
        </div>
      </div>

      <div className="spaces mt-16">
        <p>
          <span><b>Phòng: </b></span>
          <ValueOrDots value={data?.dataDangKy?.donViCongTac?.name || ""} />
        </p>
        <p>
          <span><b>Người đề xuất làm thêm giờ: </b></span>
          <ValueOrDots value={data?.dataSelect?.employeeText || ""} />
        </p>
        <div className="flex">
          <span className="spaces mt-3 mr-3 span-cong-viec"><b>Nội dung: </b></span>
          <div>
            {data?.dataSelect?.listCongViec.map((congViec: any, index: number) => (
              <p><ValueOrDots value={congViec?.congViec || ""} /></p>
            ))}

          </div>
        </div>
        <div className="flex">
          <span className="spaces mt-3 mr-3 span-cong-viec"><b>Thời gian: </b></span>
          <div>
            {data?.dataSelect?.listCongViec.map((congViec: any, index: number) => (
              <p><ValueOrDots className="text-capitalize-first" value={congViec?.ngayDkTruc ? moment(congViec?.ngayDkTruc, 'YYYY-MM-DD').format('dddd, [ngày] D [tháng] M [năm] YYYY') : ""} /></p>
            ))}
          </div>
        </div>
        <p className="spaces mt-10">
          Kính đề xuất Giám đốc và Phòng TCCB xác nhận các công việc phòng đã được thực hiện./.
        </p>
      </div>
      
      <div className="flex flex-end spaces mt-10">
        <p>
          <ValueOrDots value={""} size={15} />, ngày <ValueOrDots size={6} value={data?.dataDangKy?.ngayNop ? moment(data?.dataDangKy?.ngayNop).format("DD") : ""} /> tháng <ValueOrDots size={6} value={data?.dataDangKy?.ngayNop ? moment(data?.dataDangKy?.ngayNop).format("MM") : ""} /> năm <ValueOrDots size={10} value={data?.dataDangKy?.ngayNop ? moment(data?.dataDangKy?.ngayNop).format("YYYY") : ""} />
        </p>
      </div>

      <div className="footer flex flex-between spaces mt-16 align-start mb-100">
        <div className="text-center">
          <p className="title-footer spaces fw-600 m-0">Người đề xuất</p>
          <p className="span-footer font-italic spaces m-0">(Ký, Họ tên)</p>
        </div>
        {configDuyet.map((config: any, index: number) => (
          <div className="text-center" key={`configDuyet-${index}`}>
          <p className="title-footer spaces fw-600 m-0">{config.code === toChucHanhChinh.code ? `Trưởng phòng ${toChucHanhChinh?.name}` : config.name}</p>
          <p className="span-footer font-italic spaces m-0">(Ký, Họ tên)</p>
        </div>
        ))}
      </div>
    </div>
  );
}

export default TemplateDeXuatLamThemGio;